import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { Button } from '@peritasai/ui-components';
import type { ReactNode } from 'react';

export interface ViewAllToggleProps {
  visible: boolean;
  expanded: boolean;
  onClick: () => void;
  children: ReactNode;
}

const viewAllWrapSx = (expanded: boolean) =>
  ({
    width: '100%',
    height: expanded ? '100%' : 'auto',
    flex: expanded ? 1 : 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    mt: expanded ? '-6px' : { xs: '-8px', md: '0px' },
  }) satisfies SxProps<Theme>;

const viewAllGradientSx = {
  position: 'absolute',
  top: '-32px',
  left: '-32px',
  width: 'calc(100% + 64px)',
  height: '24px',
  background:
    'linear-gradient(180deg, rgba(255, 255, 255, 0.20) 37.88%, rgba(153, 153, 153, 0.20) 100%)',
  mixBlendMode: 'multiply',
  pointerEvents: 'none',
} satisfies SxProps<Theme>;

export const ViewAllToggle = ({
  visible,
  expanded,
  onClick,
  children,
}: ViewAllToggleProps) => {
  const theme = useTheme();

  if (!visible) {
    return null;
  }

  return (
    <Box sx={viewAllWrapSx(expanded)}>
      {expanded && <Box sx={viewAllGradientSx} />}
      <Button
        variant="text"
        size="large"
        onClick={onClick}
        sx={{
          alignSelf: 'center',
          height: '56px',
          padding: '8px 11px',
          borderRadius: '8px',
          fontSize: '15px',
          lineHeight: '20px',
          letterSpacing: '0.46px',
          marginTop: '0px',
          width: '100%',
          color: theme.palette.primary.main,
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
        }}
      >
        {children}
      </Button>
    </Box>
  );
};

export default ViewAllToggle;
